import { create } from 'zustand';
import type { BufferGeometry } from 'three';

interface TeethStore {
  upperOpacity: number;
  lowerOpacity: number;
  showGrid: boolean;
  showAxes: boolean;
  showUpperJaw: boolean;
  showLowerJaw: boolean;
  currentScanIndex: number | null;
  upperJawFile: BufferGeometry | undefined;
  lowerJawFile: BufferGeometry | undefined;

  setUpperOpacity: (opacity: number) => void;
  setLowerOpacity: (opacity: number) => void;
  toggleGrid: () => void;
  toggleAxes: () => void;
  toggleUpperJaw: () => void;
  toggleLowerJaw: () => void;
  setCurrentScanIndex: (index: number | null) => void;
  setUpperJawFile: (file: BufferGeometry | undefined) => void;
  setLowerJawFile: (file: BufferGeometry | undefined) => void;
}

export const useTeethStore = create<TeethStore>((set) => ({
  upperOpacity: 100,
  lowerOpacity: 100,
  showGrid: false,
  showAxes: false,
  showUpperJaw: true,
  showLowerJaw: true,
  currentScanIndex: null,
  upperJawFile: undefined,
  lowerJawFile: undefined,

  setUpperOpacity: (opacity) => set({ upperOpacity: opacity }),
  setLowerOpacity: (opacity) => set({ lowerOpacity: opacity }),
  // setShowGrid
  toggleGrid: () => set((state) => ({ showGrid: !state.showGrid })),
  toggleAxes: () => set((state) => ({ showAxes: !state.showAxes })),
  toggleUpperJaw: () => set((state) => ({ showUpperJaw: !state.showUpperJaw })),
  toggleLowerJaw: () => set((state) => ({ showLowerJaw: !state.showLowerJaw })),
  setCurrentScanIndex: (index) => set({ currentScanIndex: index }),
  setUpperJawFile: (file) => set({ upperJawFile: file }),
  setLowerJawFile: (file) => set({ lowerJawFile: file }),
}));
